/**
 * Typed Redux Hooks
 *
 * Pre-typed versions of useDispatch and useSelector to avoid
 * repetitive type annotations throughout the application.
 *
 * Usage:
 *   import { useAppDispatch, useAppSelector } from './hooks/reduxHooks';
 *
 *   // In a component:
 *   const dispatch = useAppDispatch();
 *   const members = useAppSelector(selectAllMembers);
 */

import { useDispatch, useSelector, type TypedUseSelectorHook } from 'react-redux';
import type { RootState, AppDispatch } from '../configureStore';

/**
 * Typed version of useDispatch hook
 * Use throughout your app instead of plain `useDispatch`
 */
export const useAppDispatch: () => AppDispatch = useDispatch;

/**
 * Typed version of useSelector hook
 * Use throughout your app instead of plain `useSelector`
 */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
